<template>
  <div class="error full-size flex-vertical">
    <div class="error-main flex-vertical">
      <div class="error-main-title font-bold-32px">
        {{title}}
      </div>  
      <div class="error-main-text font-regular-16px">
        {{message}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: {
    title: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },
  },
  // data() {
  //   return {
  //   title: null,
  //   message: null
  // }}
};
</script>

<style lang="scss" scoped>
@import "../../src/styles/colors.scss";

.error {
  background-color: $background-color;
  align-items: center;
}

.error-main {
  position: relative;
  top: 30%;
  align-items: center;
}

.error-main-title {
  text-align: center;
}

.error-main-text {
  text-align: center;
}

@media screen and (max-width: 500px) {

  .error-main {
    top: 20%;
  }

  .error-main-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .error-main-text {
    font-size: 13px;
  }
}
</style>